export const colors = {
  primary: "#00A8E8",
  secondary: "#0D7EC4",
  backgroundPrimary: "#FFFFFF",
  backgroundSecondary: "#F5F5F5",
  backgroundDark: "#1A1A1A",
  text: "#333333",
  textLight: "#666666",
  textWhite: "#FFFFFF",
  border: "#E0E0E0",
  success: "#4CAF50",
  error: "#F44336",
  warning: "#FF9800",
  darkGray: "#1E1E1E",
};
